// extracted by mini-css-extract-plugin
export default {"loading_container":"styles_loading_container__2WiWz","loading_spinne":"styles_loading_spinne__V03-Q","spin":"styles_spin__yeNUi"};